import {SharedInputEdit} from '../../components/SharedInputEdit';
import {useContext} from 'react';
import {CalculatorAdvancedModeContext} from '../../../../shared/contexts/CalculatorContext';
import {CalculatorAdvancedMode} from '../../../../shared/classes/CalculatorMode';

export function OperationsInput(): JSX.Element {
    const advancedMode = useContext(CalculatorAdvancedModeContext)!;

    return (
        <div className="operations --ctow">

            <div>

                <div>

                    <h4>Data Inputs from Customer</h4>

                    <SharedInputEdit inputName='I17_facility_opening_hours'/>
                    <SharedInputEdit inputName='I19_facility_opening_in_days_per_year'/>
                    <SharedInputEdit inputName='I21_per_of_exams_rescheduled_after_an_event'/>
                    <SharedInputEdit inputName='R14_inhouse_engineer_cost_per_hour'/>
                    <SharedInputEdit inputName='AA8_admin_fee_per_rescheduled_patient'/>

                </div>

                {
                    advancedMode[0] === CalculatorAdvancedMode.Advanced
                        ? <div>

                            <h4>Data Inputs for Surgery Dpt Impact </h4>

                            <SharedInputEdit inputName='V41_avg_surgery_lenght_in_hours'/>
                            <SharedInputEdit inputName='V43_avg_patient_intensive_care_lenght_in_hours'/>
                            {/*<SharedInputEdit inputName='avg_cost_per_hour_in_the_intensive_care_dept'/>*/}

                        </div>
                        : ''

                }

            </div>

        </div>

    );
}
